<!--
 * @Author: xiongqi 152727497758@163.com
 * @Date: 2023-09-01 20:59:08
 * @LastEditors: xiongqi 152727497758@163.com
 * @LastEditTime: 2024-02-04 22:17:42
 * @FilePath: /payroll_front/src/components/loading.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="main">
    <div class="loadingTxt">
      <i class="el-icon-loading"></i>
      <div class="text">
        解析中
      </div>
      <span>{{dot==0?'':dot==1?'.':dot==2?'..':dot==3?'...':''}}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dot: 0
    }
  },
  mounted () {
    setInterval(() => {
      this.changeDot()
    }, 200);

  },
  methods: {
    changeDot () {
      if (this.dot < 3) {
        this.dot = this.dot + 1
      } else {
        this.dot = 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: #0000004d;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .loadingTxt {
    width: 352px;
    height: 56px;
    background: #3cc390;
    border-radius: 28px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    .text {
      margin-left: 27px;
    }
    span {
      min-width: 30px;
      height: 18px;
      margin-left: 3px;
    }
  }
}
.el-icon-loading {
  font-size: 30px;
}
</style>